import * as keyapis_bell_v1_common_pb from "./v1/keyapis_bell_common_v1.pb";
import * as keyapis_bell_v1_events_pb from "./v1/keyapis_bell_events_v1.pb";
import * as keyapis_bell_v1_notification_pb from "./v1/keyapis_bell_notification_v1.pb";
import * as keyapis_bell_v1_system_pb from "./v1/keyapis_bell_system_v1.pb";

export default {
  v1: {
    resources: {
      common: keyapis_bell_v1_common_pb,
      events: keyapis_bell_v1_events_pb,
      notification: keyapis_bell_v1_notification_pb,
      system: keyapis_bell_v1_system_pb,
    },
  },
};
